
import React, { useEffect, useState } from 'react';
import { applyForCertification, fetchCertificationDetails, fetchCourseDetails, postcertificationDetails, uploadfiletos3 } from '../../service/certificationAPI';
import ApplyCertificationPopup from '../certificationPopup/ApplyCertification';
import { encryptStorage } from '../../constant';
import { CertificationDetails } from '../certificationPopup/CertificateDetailsPopup';
import { Breadcrumb } from 'antd';
import DOMPurify from 'dompurify';
const MyCertifications = ({
    hideHeader = false,
    certificates = [],
    totalRecords = 0,
    numberOfRecords = 0,
    searchTerm = "",
    onSearchChange,
    filters = {},
    onFilterChange,
    onClearFilters,
    sortColumn = "req_id",
    sortOrder = -1,
    onSortChange,
    showLoadMore,
    onShowMore,
    providers = [],
    fetchCertifications,
    setSortColumn,
    setSortOrder
}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [errorMessage, setErrorMessage] = useState("");
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showApplyPopup, setShowApplyPopup] = useState(false);
    const [applyFormData, setApplyFormData] = useState({
        certificateName: "",
        provider: "",
        materialsLink: ""
    });
    const [employeeName, setEmployeeName] = useState(encryptStorage.getItem('employeeName'))
    const [empDomain, setempDomain] = useState(encryptStorage.getItem('domain'))
    const [empId, setEmpId] = useState(encryptStorage.getItem('employeeId'))
    const [showDetails, setShowDetails] = useState(false);
    const [selectedCertificate, setSelectedCertificate] = useState(null);
    const [courses, setCourses] = useState(null)

    let breadCrumbData = [
        { title: 'Dashboard', path: '/overview', isActive: true },
        { title: 'How Do I ?', path: '/', isActive: true },
        { title: 'Certifications', path: '/usercertification', isActive: false }
    ];

    //SQ- 1.23- 1.43 : fetchCertifications

    // useEffect(() => {
    //     fetchCertifications();
    // }, [currentPage, currentnumberofRecords, pageSize, searchTerm, sortColumn, sortOrder]);

    const groupId = encryptStorage.getItem('groupid');
    const domain = encryptStorage.getItem('domain');


    // const fetchCertifications = async () => {
    //     setIsLoading(true);
    //     try {
    //         const params = {
    //             emp_id: empId,
    //             group_id: groupId,
    //             domain: domain,
    //             currentnumber_of_records: currentnumberofRecords,
    //             page_size: pageSize,
    //             search_term: searchTerm,
    //             sort_column: sortColumn,
    //             sort_order: sortOrder,
    //             "filter.provider": filters.provider,
    //             "filter.created_date.from": filters.createdFrom,
    //             "filter.created_date.to": filters.createdTo
    //         };

    //         // Apply filters as individual query params (not nested)
    //         // if (filterValue.provider) {
    //         //     params["filter.provider"] = filterValue.provider;
    //         // }
    //         // if (filterValue.createdFrom) {
    //         //     params["filter.created_date.from"] = filterValue.createdFrom;
    //         // }
    //         // if (filterValue.createdTo) {
    //         //     params["filter.created_date.to"] = filterValue.createdTo;
    //         // }

    //         console.log(params, "Final Params");
    //         const response = await fetchCertificationDetails(params);
    //         if (response.status === "success") {
    //             setCertificates(response.data.certificates || []);
    //             setTotalRecords(response.data.meta?.total_count || 0);
    //             setNumberOfRecords(response.data.meta?.count || 0);
    //             setProviders(response.data.providers || []); // Add this line

    //         }
    //     } catch (error) {
    //         console.error("Error fetching certifications:", error);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };
    //SQ 5.0 - 5.7 : Handles the search
    const handleSearchChange = (event) => {
        onSearchChange(event.target.value);
    };

    const handleCertificateClick = (certificate) => {
        setSelectedCertificate(certificate);
        setShowDetails(true);
    };

    // SQ-3.12 - 3.14 : Handle the apply click and certificate Submission
    const handleApplyClick = () => {
        setShowApplyPopup(true)
    };

    const handleSubmitApplication = async (applicationData) => {
        try {
            await applyForCertification(applicationData);
            await fetchCertifications()
            setShowApplyPopup(false);
        } catch (error) {
            setErrorMessage("Failed to submit application");
        }
    };
    // SQ- 9.1 - 9.19 Handle sorting
    const handleSortChange = (column) => {
        if (sortColumn === column) {
            setSortOrder(prev => -prev); // Toggle between 1 (↑) and -1 (↓)
        } else {
            setSortColumn(column);
            setSortOrder(1); // New column starts with ascending (↑)
        }
    };

    // SQ 3.5 - 3.18  Handle filter change

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        onFilterChange(name, value); // Delegate to parent
    };

    const handleApplyFilters = () => {
        fetchCertifications();
    };

    // const handleClearFilters = () => {
    //     // Create a completely clean params object
    //     const cleanParams = {
    //         emp_id: empId,
    //         group_id: groupId,
    //         domain: domain,
    //         current_number_of_records: 0, // Reset to first page
    //         page_size: pageSize,
    //         sort_column: sortColumn,
    //         sort_order: sortOrder
    //     };

    //     // Reset all local state
    //     setFilterValue({
    //         provider: "",
    //         createdFrom: "",
    //         createdTo: ""
    //     });
    //     setSearchTerm("");
    //     setCurrentPage(1);

    //     // Make the API call with clean params immediately
    //     fetchCertificationDetails(cleanParams)
    //         .then(response => {
    //             if (response.status === "success") {
    //                 setCertificates(response.data.certificates || []);
    //                 setTotalRecords(response.data.meta?.total_count || 0);
    //                 setNumberOfRecords(response.data.meta?.count || 0);
    //                 setProviders(response.data.providers || []);
    //             }
    //         })
    //         .catch(error => {
    //             console.error("Error fetching certifications:", error);
    //             setErrorMessage("Failed to fetch certifications");
    //         });
    // };



    const handleClearFilters = () => {
        // Delegate clearing to parent
        onFilterChange('provider', '');
        onFilterChange('createdFrom', '');
        onFilterChange('createdTo', '');
        onSearchChange('');
    };

    const handleShowMore = () => {
        onShowMore();
    };

    //2.31-2.40 : Handles the status for display
    const getStatusDisplay = (certificate) => {
        // Safely get field values
        const getFieldValue = (field, defaultValue = '') => {
            if (!field || !field.Valid) return defaultValue;
            return field.String !== undefined ? field.String :
                field.Bool !== undefined ? field.Bool :
                    defaultValue;
        };

        // Get all relevant values
        const initialApproval = getFieldValue(certificate.initial_ph_approval, "pending").toLowerCase();
        const isPaymentCompleted = getFieldValue(certificate.is_payment_completed, false);
        const financialApproval = getFieldValue(certificate.financial_approval, "").toLowerCase();
        const certificationCompletion = getFieldValue(certificate.certification_completion_approval, "pending").toLowerCase();
        const isCourseCompleted = getFieldValue(certificate.is_course_completion, false);
        const passReattemptStatus = getFieldValue(certificate.pass_reattempt_status, "").toLowerCase();


        // Determine statuses for each step
        let initialStatus = "pending";
        let paymentStatus = "pending";
        let completionStatus = "pending";
        let statusText = "Pending";
        let statusClass = "pending";

        // Initial Approval Status
        if (initialApproval === "rejected") {
            initialStatus = "rejected";
            statusText = "Rejected";
            statusClass = "rejected";
        }
        else if (initialApproval === "approved") {
            initialStatus = "approved";

            // Payment Status
            if (isPaymentCompleted) {
                paymentStatus = "approved";
                if (certificationCompletion === "approved" && passReattemptStatus === "failed") {
                    statusText = "Certification Failed"; // Set status text for failed certification
                    completionStatus = "rejected"; // Set class to rejected
                } else {
                    // Certification Completion Status
                    if (certificationCompletion === "approved") {
                        completionStatus = "approved";
                        statusText = "Course Completed";
                        statusClass = "approved";
                    }
                    else if (certificationCompletion === "inprogress") {
                        completionStatus = "inprogress";
                        statusText = "Certification In Progress";
                        statusClass = "inprogress";
                    }
                    else if (certificationCompletion === "rejected") {
                        completionStatus = "rejected";
                        statusText = "Certification Rejected";
                        statusClass = "rejected";
                    }
                    else {
                        statusText = "Payment Completed";
                        statusClass = "approved";
                    }
                }
            }
            else if (financialApproval === "inprogress") {
                paymentStatus = "inprogress";
                statusText = "Payment In Progress";
                statusClass = "inprogress";
            }
            else {
                statusText = "Approved";
                statusClass = "approved";
            }
        }
        else if (initialApproval === "inprogress") {
            initialStatus = "inprogress";
            statusText = "Initial Approval In Progress";
            statusClass = "inprogress";
        }

        return {
            statusText,
            statusClass,
            initialStatus,
            paymentStatus,
            completionStatus
        };
    };

    const uploadCertificateToS3 = async (fileData) => {
        try {

            // Convert the File object to ArrayBuffer
            const file = fileData.certificate_file;
            const arrayBuffer = await file.arrayBuffer();

            // Convert ArrayBuffer to Uint8Array (byte array)
            const byteArray = new Uint8Array(arrayBuffer);

            // Convert to regular array (if your backend expects []byte)
            const bytes = Array.from(byteArray);

            // Prepare the data in the format your backend expects
            const requestData = {
                request_id: fileData.request_id,
                emp_id: fileData.emp_id,
                certificate_file: bytes,
                certificate_name: fileData.certificate_name,
                provider: fileData.provider,
                specialization: fileData.specialization,
                year_of_completion: fileData.year_of_completion,
                original_filename: fileData.original_filename,
                is_reupload: fileData.is_reupload
            };

            // Call the uploadfiletos3 function with the byte array
            const response = await uploadfiletos3(requestData);

            if (response.status === "success") {
                setShowDetails(false)
                await fetchCertifications()
                return {
                    url: response.data.certificate_url,
                    success: true
                };

            } else {
                throw new Error(response.message || "Failed to upload certificate");
            }
        } catch (error) {
            console.error('Upload error:', error);
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    //SQ_2.17 - 2.30 : handles the approval status
    const postCertificationApproval = async (approvalData) => {
        try {
            setIsLoading(true);

            const data = await postcertificationDetails(approvalData);
            return data;
        } catch (error) {
            console.error('Approval error:', error);
            setErrorMessage("Failed to submit approval");
            throw error;
        } finally {
            setIsLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(Date.UTC(year, month - 1, day)); // Treat as UTC
        const options = { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' };
        return date.toLocaleDateString('en-US', options).replace(/\//g, '-');
    };


    const getFieldValue = (field, defaultValue = '') => {
        if (!field || !field.Valid) return defaultValue;
        return field.String !== undefined ? field.String :
            field.Bool !== undefined ? field.Bool :
                defaultValue;
    };

    return (
        <div className="">
            <div >
                {/* Certifications Table */}
                <table className="table bg-white hive-grid mb-3 table-borderless approval-table">
                    <thead className="hive-table-head">
                        <tr>
                            <th
                                onClick={() => handleSortChange("req_id")}
                                className={`bold-text font-12 ${sortColumn === "req_id" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                    }`}
                            >
                                Request ID
                                <span className="ps-2">
                                    <img
                                        src={sortColumn === "req_id"
                                            ? sortOrder === 1
                                                ? "/Images/sort-icon.svg"    // ↑ when ascending
                                                : "/Images/Sort-up.svg"  // ↓ when descending
                                            : "/Images/sort-icon.svg"}
                                        alt="Sorticon"
                                        className={`hive-table-sort ${sortColumn === "req_id" ? "active-sort" : ""
                                            }`}
                                    />
                                </span>
                            </th>
                            <th
                                onClick={() => handleSortChange("certificate_name")}
                                className={`bold-text font-12 ${sortColumn === "certificate_name" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                    }`}
                            >
                                Certification Name
                                <span className="ps-2">
                                    <img
                                        src={sortColumn === "certificate_name"
                                            ? sortOrder === 1
                                                ? "/Images/sort-icon.svg"    // ↑ when ascending
                                                : "/Images/Sort-up.svg"  // ↓ when descending
                                            : "/Images/sort-icon.svg"}
                                        alt="Sorticon"
                                        className={`hive-table-sort ${sortColumn === "certificate_name" ? "active-sort" : ""
                                            }`}
                                    />
                                </span>
                            </th>
                            <th
                                onClick={() => handleSortChange("provider")}
                                className={`bold-text font-12 ${sortColumn === "provider" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                    }`}
                            >
                                Provider
                                <span className="ps-2">
                                    <img
                                        src={sortColumn === "provider"
                                            ? sortOrder === 1
                                                ? "/Images/sort-icon.svg"    // ↑ when ascending
                                                : "/Images/Sort-up.svg"  // ↓ when descending
                                            : "/Images/sort-icon.svg"}
                                        alt="Sorticon"
                                        className={`hive-table-sort ${sortColumn === "provider" ? "active-sort" : ""
                                            }`}
                                    />
                                </span>
                            </th>
                            <th
                                onClick={() => handleSortChange("created_date")}
                                className={`bold-text font-12 ${sortColumn === "created_date" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                    }`}
                            >
                                Created On
                                <span className="ps-2">
                                    <img
                                        src={sortColumn === "craeted_on"
                                            ? sortOrder === 1
                                                ? "/Images/sort-icon.svg"    // ↑ when ascending
                                                : "/Images/Sort-up.svg"  // ↓ when descending
                                            : "/Images/sort-icon.svg"}
                                        alt="Sorticon"
                                        className={`hive-table-sort ${sortColumn === "created_date" ? "active-sort" : ""
                                            }`}
                                    />
                                </span>
                            </th>
                            <th
                                onClick={() => handleSortChange("duration")}
                                className={`bold-text font-12 ${sortColumn === "duration" ? (sortOrder === 1 ? "asc" : "desc") : ""
                                    }`}
                            >
                                Completion Duration
                                <span className="ps-2">
                                    <img
                                        src={sortColumn === "duration"
                                            ? sortOrder === 1
                                                ? "/Images/sort-icon.svg"    // ↑ when ascending
                                                : "/Images/Sort-up.svg"  // ↓ when descending
                                            : "/Images/sort-icon.svg"}
                                        alt="Sorticon"
                                        className={`hive-table-sort ${sortColumn === "completion_duration" ? "active-sort" : ""
                                            }`}
                                    />
                                </span>
                            </th>
                            <th className="bold-text font-12">Materials Path Link</th>
                            <th className="bold-text font-12" >
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {certificates?.map(cert => {
                            const { statusText, initialStatus, paymentStatus, completionStatus, statusClass } = getStatusDisplay(cert);
                            const isPending = getFieldValue(cert.initial_ph_approval, "pending").toLowerCase() === "pending";
                            return (
                                <tr key={cert.req_id} className="hive-table-data regular-text">
                                    <td>
                                        {getFieldValue(cert.is_payment_completed, "").toLowerCase() === "completed" ? (
                                            // Clickable version when payment is completed
                                            <span
                                                className="text-primary cursor-pointer hover-underline"
                                                onClick={() => handleCertificateClick(cert)}
                                                style={{
                                                    color: '#0d6efd',
                                                    textDecoration: 'underline',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                {cert.req_id}
                                            </span>
                                        ) : (
                                            // Non-clickable version when payment is not completed
                                            <span className="text-secondary">
                                                {cert.req_id}
                                            </span>
                                        )}
                                    </td>
                                    <td>{cert.certificate_name}
                                        {cert.client_dependency.Bool && (
                                            <span className="client-badge ms-2">Client</span>
                                        )}
                                    </td>
                                    <td>{cert.provider}</td>
                                    <td>{formatDate(cert.created_date)}</td>
                                    <td>
                                        {cert.duration.String !== "0" ? cert.duration.String
                                            : '-'}
                                    </td>
                                    <td style={{
                                        maxWidth: "200px",
                                        wordBreak: "break-all",
                                        whiteSpace: "normal",
                                    }}>
                                        <a
                                            href={DOMPurify.sanitize(cert.materials.String)}
                                            target="_blank"
                                            rel='noopener noreferrer'
                                            className='text-decoration-none table-name-style'
                                            title={cert.materials.String}
                                            style={{
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "100%",
                                                verticalAlign: "middle"
                                            }}
                                        >
                                            {cert.materials.String
                                                .replace(/^https?:\/\/(www\.)?/, '') // Remove http(s):// and optional www.
                                                .substring(0, 30)} {/* Show first 30 characters */}
                                            {cert.materials.String.length > 30 && '...'} {/* Add ellipsis if truncated */}
                                        </a>

                                    </td>
                                    <td>
                                        <div className="progress-indication-bar d-flex flex-column justify-content-center align-items-start">
                                            <span className={`font-11 mb-1 ${statusClass}`}>
                                                {statusText}
                                            </span>
                                            <div className="d-flex align-items-center justify-content-center gap-1">
                                                {/* Initial Approval */}
                                                <span className={`progress-step ${initialStatus}`}></span>
                                                <span className="progress-line"></span>

                                                {/* Payment Completion */}
                                                <span className={`progress-step ${paymentStatus}`}></span>
                                                <span className="progress-line"></span>

                                                {/* Certification Completion */}
                                                <span className={`progress-step ${completionStatus}`}></span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <p className="font-12 pagination">
                    Showing<span className="bold-text mx-1">{numberOfRecords}</span> of
                    <span className="bold-text mx-1">{totalRecords}</span> Records
                </p>

                {certificates?.length >= 10 && (
                    <div className="text-center">
                        <button className="btn show-more-btn" onClick={handleShowMore}>
                            Show More
                        </button>
                    </div>
                )}
            </div>

            {/* Toast Notifications */}
            {/* {showErrorToast && (
                <div className="toast show position-fixed bottom-0 end-0 m-3" role="alert" aria-live="assertive" aria-atomic="true">
                    <div className="toast-header bg-danger text-white">
                        <strong className="me-auto">Error</strong>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={() => setShowErrorToast(false)}
                        ></button>
                    </div>
                    <div className="toast-body">
                        {errorMessage}
                    </div>
                </div>
            )}

            {showSuccessToast && (
                <div className="toast show position-fixed bottom-0 end-0 m-3" role="alert" aria-live="assertive" aria-atomic="true">
                    <div className="toast-header bg-success text-white">
                        <strong className="me-auto">Success</strong>
                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={() => setShowSuccessToast(false)}
                        ></button>
                    </div>
                    <div className="toast-body">
                        {successMessage}
                    </div>
                </div>
            )} */}
            {showApplyPopup && (
                <ApplyCertificationPopup
                    show={showApplyPopup}
                    onClose={() => setShowApplyPopup(false)}
                    onSubmit={handleSubmitApplication}
                    employeeId={empId}
                    employeeName={employeeName}
                    domain={empDomain}
                    courses
                    appliedCertificates={certificates?.filter(cert => cert?.initial_ph_approval?.String !== "Rejected")?.map(cert => cert.certificate_id)}

                />
            )}
            {showDetails && selectedCertificate && (
                <CertificationDetails
                    showDetails={showDetails}
                    setShowDetails={setShowDetails}
                    onClose={() => {
                        setShowDetails(false);
                        fetchCertifications()
                    }}
                    certificateDetails={selectedCertificate}
                    onUploadCertificate={uploadCertificateToS3}
                    onPostApproval={postCertificationApproval}
                />
            )}
        </div>
    );
};

export default MyCertifications;
